import I18n from "i18n-js"
import 'src/translations'

I18n.defaultLocale = window.planr.defaultLocale
I18n.locale = window.planr.locale
